import { Box, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import AvatarWithLoader from 'components/avatar-with-loader'
import moment from 'moment'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { NivosMessage } from 'types/nivos-message'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

interface OwnProps {
  type: 'sent' | 'received'
  message: NivosMessage
}

type AppProps = StateProps & DispatchProps & OwnProps

const ChatBubbleFC: React.FC<any> = (props: AppProps) => {
  const { theme, type, message } = props

  return (
    <>
      {type === 'received' && (
        <Box display={'flex'}>
          <AvatarWithLoader
            src={message.createdBy.image?.url ?? ''}
            containerProps={{ sx: { margin: 3 } }}
          />
          <Box width={1}>
            <Box
              width={'fit-content'}
              padding={2}
              marginTop={2}
              marginBottom={1}
              maxWidth={0.65}
              marginRight={'auto'}
              borderRadius={4}
              bgcolor={theme.quaternaryColor}
            >
              <Typography>{message.message}</Typography>
            </Box>
            <Typography
              variant={'body2'}
              width={'fit-content'}
              marginBottom={2}
              marginRight={'auto'}
              color={'#878787'}
            >
              {moment(message.createdAt).fromNow()}
            </Typography>
          </Box>
        </Box>
      )}
      {type === 'sent' && (
        <Box display={'flex'}>
          <Box width={1}>
            <Box
              width={'fit-content'}
              padding={2}
              marginTop={2}
              marginBottom={1}
              maxWidth={0.65}
              marginLeft={'auto'}
              borderRadius={4}
              bgcolor={theme.secondaryColor}
            >
              <Typography color={theme.primaryColor}>
                {message.message}
              </Typography>
            </Box>
            <Typography
              variant={'body2'}
              width={'fit-content'}
              marginBottom={2}
              marginLeft={'auto'}
              color={'#878787'}
            >
              {moment(message.createdAt).fromNow()}
            </Typography>
          </Box>
          <AvatarWithLoader
            src={message.createdBy.image?.url ?? ''}
            containerProps={{ sx: { margin: 3 } }}
          />
        </Box>
      )}
    </>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const ChatBubble = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatBubbleFC) as React.FC<OwnProps>

export default ChatBubble
